<template>
    <div class="relative inline-block">
        <svg
            @click="open = !open"
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
            />
        </svg>
        <SlideOver :show="open" @close="open = false">
            <ul>
                <li v-for="(suggestion, index) in suggestions" :key="index">
                    <button
                        class="mt-1 p-2 text-sm bg-gray-50 hover:bg-indigo-100 block w-full rounded-md text-left text-gray-500 hover:text-gray-700"
                        @click="selectSuggestion(suggestion)"
                    >
                        {{ suggestion.text }}
                    </button>
                </li>
            </ul>
        </SlideOver>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['close', 'select-suggestion'],
    name: 'SuggestionsPanel',

    components: {
        SlideOver,
    },

    props: {
        suggestions: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            open: false,
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
        selectSuggestion(suggestion) {
            this.$emit('select-suggestion', suggestion.text);
            this.open = false;
        },
    },
};
</script>
